import { ROUTES } from "consts";
import { useNavigate } from "react-router-dom";
import useLayoutConfigStore from "store/layout-config-store/useLayoutConfigStore";
import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";

const withHeader = (Component: React.ComponentType<any>) => {
  return (props: any) => {
    const { tgUserId, tgUserName, tgPhotoUrl } = useUserStoreV2();
    const { isShowHeader } = useLayoutConfigStore();

    const navigate = useNavigate();

    const handleLogin = async () => {
      try {
        if (!tgUserId || !tgUserName) {
          navigate(ROUTES.portfolio);
        }
      } catch (error) {
        console.error("Error while logging in", error);
      }
    };

    const navigateToPorfolio = () => {
      navigate(ROUTES.portfolio);
    };

    const navigateToExplorer = () => {
      navigate(ROUTES.explorer);
      // navigate(ROUTES.trade);
    };
    return (
      <Component
        tgUserName={tgUserName}
        tgPhotoUrl={tgPhotoUrl}
        isShowHeader={isShowHeader}
        navigateToPorfolio={navigateToPorfolio}
        navigateToExplorer={navigateToExplorer}
        {...props}
      />
    );
  };
};

export default withHeader;
